import React from 'react';
import { AppBar, Toolbar, Typography, IconButton, Button, Box } from '@mui/material';
import { ExitToApp, Dashboard as DashboardIcon, MonitorHeart } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { performLogout } from '../../utils/logout';

const AdminLayout = ({ children, title = 'Admin Dashboard' }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await performLogout(navigate);
  };

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <DashboardIcon sx={{ mr: 2 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontFamily: '"Playfair Display", Georgia, serif' }}>
            JyotishSastra - {title}
          </Typography>
          <Button color="inherit" onClick={() => navigate('/admin/invitations')} sx={{ mr: 2 }}>
            Invitations
          </Button>
          <Button color="inherit" onClick={() => navigate('/admin/revenue')} sx={{ mr: 2 }}>
            Revenue
          </Button>
          <Button color="inherit" onClick={() => navigate('/admin/withdrawals')} sx={{ mr: 2 }}>
            Withdrawals
          </Button>
          <Button color="inherit" onClick={() => navigate('/admin/users')} sx={{ mr: 2 }}>
            Users
          </Button>
          <Button color="inherit" onClick={() => navigate('/admin/astrologers')} sx={{ mr: 2 }}>
            Astrologers
          </Button>
          <Button color="inherit" onClick={() => navigate('/admin/consultations')} sx={{ mr: 2 }}>
            Consultations
          </Button>
          <Button color="inherit" onClick={() => navigate('/admin/ledger')} sx={{ mr: 2 }}>
            Ledger
          </Button>
          <Button color="inherit" onClick={() => navigate('/admin/monitor')} startIcon={<MonitorHeart />} sx={{ mr: 2 }}>
            Monitor
          </Button>
          <Button color="inherit" onClick={() => navigate('/admin/push-notifications')} sx={{ mr: 2 }}>
            Push Notifications
          </Button>
          <Button color="inherit" onClick={() => navigate('/vedic-tools')} sx={{ mr: 2 }}>
            🪷 Vedic Tools
          </Button>
          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToApp />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box sx={{ minHeight: 'calc(100vh - 64px)' }}>
        {children}
      </Box>
    </>
  );
};

export default AdminLayout;
